import { createI18n } from "vue-i18n";
import Cookies from "js-cookie";

import en from "@/lang/en.json";
import de from "@/lang/de.json";

export const messages = {
  en: en,
  de: de,
};

const i18n = createI18n({
  locale: Cookies.get("locale") || "de",
  fallbackLocale: "de",
  globalInjection: true,
  legacy: false,
  messages,
  modifiers: {
    // Example "custom modifiers example: @.snakeCase:{'message.snake'}"
    snakeCase: (str) => str.split(" ").join("_"),
  },
});

import "moment/dist/locale/de";
import moment from "moment/min/moment-with-locales";

export const changeLocale = (locale) =>
{
  if (!locale) locale = "de";

  Cookies.set("locale", locale);
  i18n.locale = locale;
  moment().locale(locale);
  //console.log("CHANGELOCALE", i18n.locale, locale);
};

export default i18n;
